import { graphql } from "react-relay";

export const EDIT_SUBSCRIBER_CONFIG_MUTATION = graphql`
	mutation editSubscriberConfigButton_EditSubscriberConfigMutation(
		$offerId: ID!
		$title: String
		$imageId: ID
		$visibility: SubscriberVisibilityInput
		$licenseProductId: ID
		$courseContentProductId: ID
		$certificationProductId: ID
	) {
		Admin {
			Offer {
				editSubscriberConfig(
					offerId: $offerId
					title: $title
					imageId: $imageId
					visibility: $visibility
					licenseProductId: $licenseProductId
					courseContentProductId: $courseContentProductId
					certificationProductId: $certificationProductId
				) {
					title
					image {
						id
						url
					}
					visibilityConfigs {
						configType
						... on AfterDateTimeVisibilityTreeConfig {
							dateTime
						}
						... on NotAfterDateTimeVisibilityTreeConfig {
							dateTime
						}
					}
					selectedVersion
					licenseProduct {
						id
						title
					}
					courseContentProduct {
						id
						title
					}
					certificationProduct {
						id
						title
					}
				}
			}
		}
	}
`;
